import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { AppUseSelector } from '../redux/hooks'
import { membershipNameType, membershipType } from '../utils/constant'
import WithNav from '../containers/WithNav'
import { LOGIN, NOT_FOUND, STORIES } from './routeConstant'
import Header from 'containers/layout/header'
import { isSunday } from '../utils/utils'
import FreeTrialNotification from '../containers/notification/FreeTrialNotification'
import OverdueInvoiceModal from '../containers/modal/overdue-invoice-modal'
import WordPocket from '../containers/word-pocket/WordPocket'
import { useWordPocketEnabled } from '../containers/word-pocket/useWordPocketEnabled'
import LanguageNotice from '../containers/language-notice/LanguageNotice'

interface IMyRouteProps {
  component: React.ComponentType<any>
  status: membershipType
  currentStep: number
  rest?: any
  showNav?: boolean
  showDashboard?: boolean
  showCorrections?: boolean
  isMeeting?: boolean
  showHeader?: boolean
}

const PrivateRoute: React.FC<IMyRouteProps> = ({
  component: Component,
  showNav,
  showDashboard,
  showHeader = true,
  ...rest
}) => {
  const location = useLocation()
  const { membership, subscriptionStatus } = AppUseSelector((state) => state.user)
  const { isMobNav } = AppUseSelector(({ dashboard }) => dashboard)
  const pocketEnabled = useWordPocketEnabled()
  const authToken = localStorage.getItem('authToken')
  const isFree = membership?.name === membershipNameType.Free
  const isOverdue = subscriptionStatus === 'past_due' || subscriptionStatus === 'unpaid'
  const isPro = membership?.name === membershipNameType.Pro
  const isTeacher = membership?.name === membershipNameType.Teacher
  const isDashboard = showDashboard && isTeacher

  const renderComponent = () => {
    if (!showHeader) {
      return <Component />
    }

    if (showNav) {
      return (
        <div className={!isMobNav ? 'z_index_div common_page' : 'common_page'}>
          <div
            className={
              isFree && !isSunday() ? 'section_div scroll_contain_div_is_free' : 'section_div scroll_contain_div'
            }
          >
            <WithNav step={rest.currentStep}>
              <Component />
            </WithNav>
          </div>
        </div>
      )
    }

    if (!showNav && !isTeacher && !isDashboard) {
      return (
        <div className='common_page'>
          <div className='section_div'>
            <Component />
          </div>
        </div>
      )
    }

    if (isTeacher && !showNav) {
      return (
        <div className='common_page'>
          <div className='section_div'>
            <Component />
          </div>
        </div>
      )
    }

    if (!showNav && isPro) {
      return (
        <div className='common_page'>
          <div className='section_div'>
            <Component />
          </div>
        </div>
      )
    }

    return <Navigate to={NOT_FOUND} />
  }

  return authToken ? (
    <>
      {/* "maayot is now in <language>.": once, above the header, for learners whose language was detected. */}
      {showHeader && <LanguageNotice />}
      {showHeader && <Header />}
      {renderComponent()}
      <FreeTrialNotification />
      <OverdueInvoiceModal show={isOverdue} />
      {/* The pouch shows on the reading steps and the learner's home; pocketed words are underlined everywhere. */}
      {pocketEnabled && <WordPocket show={!!showNav || location.pathname === STORIES} readingStep={!!showNav} />}
    </>
  ) : (
    <Navigate to={LOGIN} state={{ from: location }} replace />
  )
}

const mapStateToProps = (state: any) => ({
  currentStep: state.story.currentStep,
  status: state.user.membership.status,
})

export default connect(mapStateToProps)(PrivateRoute)
